import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import useStyles from "./style";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Typography } from "@mui/material";

const DropZone = (props) => {
  const { upload, setUploadErros } = props;
  const classes = useStyles();
  const maxFileSize = 5242880;

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      return {
        code: "file-too-large",
        message: `File (${file?.name}) size is larger than ${formatBytes(
          maxFileSize
        )}`,
      };
    }
    return null;
  };

  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: {
    "image/*": [".jpeg", ".jpg", ".png", ".gif"],
    },
    validator: (file) => {
      const lengthError = fileLengthValidator(file);
      // if (file.type === "image/gif") {
      //   return {
      //     code: "invalid-file-type",
      //     message: `File (${file?.name}) type is not supported. Only JPEG, JPG, and PNG are allowed.`,
      //   };
      // }
      if (lengthError) {
        return lengthError;
      }

      return null;
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles) {
        upload(acceptedFiles);
      }
    },
  });

  useEffect(() => {
    setUploadErros(fileRejections);
  }, [fileRejections, setUploadErros]);

  return (
    <>
      <section {...getRootProps()} className={classes.root} onClick={open}>
        <input {...getInputProps()} />
        <section className={classes.container}>
          <CloudUploadIcon sx={{ fontSize: 48 }} className={classes.icon} />
          <Typography className={classes.icon} variant="body1">
            Upload
          </Typography>
        </section>
      </section>
    </>
  );
};

export default DropZone;
